import React, { useState } from "react";
import { texts } from "../lib/constants";

function QuizGroupsQuestions({
  language,
  userData,
  questions,
  setCurrentQuestionsGroup,
  setUserTypeForm,
  isActiveQuestionsGroups,
  setIsActiveQuestionsGroups,
  setIsActiveVotingGroups
}) {
  const [isActive, setisActive] = useState();
  const updateCurrentGroup = (groupNumber) => {
    setCurrentQuestionsGroup(groupNumber);
    setIsActiveQuestionsGroups(true);
    setIsActiveVotingGroups();
    setisActive(groupNumber);
  };

  return (
    <div>
      {questions?.map((question, key) => {
        let groupQuestionsNumber;
        if (key < 35) {
          groupQuestionsNumber = Math.floor(key / 5 + 1); // 7 grupos de 5
        } else {
          groupQuestionsNumber = 8; // Último grupo con 2 preguntas
        }

        let questionNumber = key + 1;
        // Mostrar solo una vez por grupo
        if (
          (key < 35 && key % 5 === 0) || // Cada 5 preguntas en los primeros 7 grupos
          (key === 35) // Primera pregunta del grupo 8 (último grupo)
        ) {
          return (
            <div
              onClick={() => {
                updateCurrentGroup(groupQuestionsNumber);
                setUserTypeForm("questions");
                window.scrollTo(0, 0);
              }}
              className={
                groupQuestionsNumber === isActive && isActiveQuestionsGroups
                  ? "questions questions-selected text-body-2"
                  : "questions text-body-2"
              }
              key={key}
            >
              <div>
                {groupQuestionsNumber < 10 ? 0 : null}
                {groupQuestionsNumber}. {texts[language].questionGroupText}{" "}
              </div>
              {userData && userData?.questions ? (
                userData?.questions[
                  groupQuestionsNumber < 10
                    ? "G0" + groupQuestionsNumber
                    : "G" + groupQuestionsNumber
                ]?.done === true ? (
                  <div>
                    <img
                      style={{ paddingTop: "12px" }}
                      alt="check"
                      src="/assets/img/icon-success.png"
                    ></img>
                  </div>
                ) : userData?.questions[
                    groupQuestionsNumber < 10
                      ? "G0" + groupQuestionsNumber
                      : "G" + groupQuestionsNumber
                  ] ? (
                  <span>
                    {
                      Object.keys(
                        userData?.questions[
                          groupQuestionsNumber < 10
                            ? "G0" + groupQuestionsNumber
                            : "G" + groupQuestionsNumber
                        ]
                      ).length
                    }{" "}
                    <span>
                      {texts[language].of}{" "}
                      {groupQuestionsNumber === 8 ? 2 : 5}
                    </span>
                  </span>
                ) : (
                  <div className="empty-div"></div>
                )
              ) : (
                <div className="empty-div"></div>
              )}
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}

export default QuizGroupsQuestions;
